import React from 'react';
import { Box, Stack, useTheme } from '@mui/material';

const CopierTemplatesPageSkeleton = () => {
  const theme = useTheme();

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={2}>
        <Stack spacing={1} mt={2}>
          {[...Array(6)].map((_, i) => (
            <Box
              sx={{
                p: { xs: 1, md: 1.25 },
                borderRadius: 2,
                bgcolor: theme.palette.action.hover,
                height: { xs: '55px', md: '64px' }
              }}
              key={i}
            ></Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default CopierTemplatesPageSkeleton;
